export function fetchGiftAlternatives(priceFilter) {
    let algoliaApiKey = '3ab971690631e98d4a7f89e95acc9ce7';
    let algoliaApplicationId = 'testing0RMGFBHPCP';
    let algoliaEnv = 'QA'; // 'LOCAL';

    if (window.location.host.indexOf('regiongold.com') >= 0) {
        algoliaEnv = 'QA';

        if (window.location.host.indexOf('qa1.') >= 0 || window.location.host.indexOf('stg.') >= 0) {
            algoliaEnv = 'PREPROD';
        }
    }

    if (window.location.host.indexOf('gucci.com') >= 0) {
        algoliaApiKey = '3ca17c2ebda5c3b2cde891f9ed8ea40b';
        algoliaApplicationId = 'HKOOLREUMF';
        algoliaEnv = 'UNO';
    }

    const algoiaAgent = 'Algolia%20for%20vanilla%20JavaScript%20(lite)%203.32.1';
    const query = `x-algolia-agent=${algoiaAgent}&x-algolia-application-id=${algoliaApplicationId}&x-algolia-api-key=${algoliaApiKey}`;

    const todayDate = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, '');
    const onlineDateFilter = [[`onlineDate <= ${todayDate}`]];

    const diyFilter = 'categories_en.categoryLevel2_en:-> DIY';
    const exoticFilter = `isExotic:false`;
    const dangerousFilter = 'isDangerous:false';

    const requestBody = {
        numericFilters: onlineDateFilter.concat(priceFilter || []),
        facetFilters: [['sellableIn:us'], ['inStock:true'], [diyFilter], [exoticFilter], [dangerousFilter]]
    };
    const url = `https://${algoliaApplicationId}-dsn.algolia.net/1/indexes/NorthAmerica_Catalog_${algoliaEnv}/query?${query}`;
    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody)
    }).then(response => response.json());
}
